export const FIELD_TITLE = 1
export const FIELD_DESCRIPTION = 2
export const FIELD_KEYWORDS = 3
export const FIELD_PAGE_HEAD = 4
export const FIELD_TEXT = 5
